// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"443":"about","995":"management"}[chunkId] + "." + {"443":"b41fc5b5","995":"9c6ae1b0"}[chunkId] + ".js";
};